import { render } from "./andarHome.vue?vue&type=template&id=41bca571&scoped=true"
import script from "./andarHome.vue?vue&type=script&lang=js"
export * from "./andarHome.vue?vue&type=script&lang=js"

import "../assets/css/game_ab.css?vue&type=style&index=0&id=41bca571&scoped=true&lang=css"
import "./andarHome.vue?vue&type=style&index=1&id=41bca571&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bca571"]])

export default __exports__